import { Controller } from "stimulus"
import Choices from "choices.js"

export default class extends Controller {
  connect() {
    // console.log('choicesjs controller');
    const choices = new Choices(this.element, {
      removeItems: true,
      removeItemButton: true,
      shouldSort: false,
      classNames: {
        containerOuter: 'choices',
        containerInner: 'choices_custom_inner',
        placeholder: 'choices_custom_placeholder',
      }
    });

    const controller = this

    choices.passedElement.element.addEventListener('change', function (e) {
      e.stopImmediatePropagation()
      e.stopPropagation()
      const { currentValue } = e.currentTarget.dataset
      const newValue = e.detail.value
      // console.log('current val', currentValue);
      // console.log('choices', choices);
      if (
        (currentValue == 'single_select' || currentValue == 'multi_select') &&
        (newValue != 'single_select' && newValue != 'multi_select')
      ) {
        if (confirm('Are you sure you want to change the question type? This will remove all the options you created')) {
          controller.dispatch('change', e)
        } else {
          // console.log('not confirmed!!!');
          choices.setChoiceByValue(currentValue);
        }
      } else {
        controller.dispatch('change', e)
      }
    })

    this.choices = choices
  }
}
